import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { FeaturesComponent } from './pages/features/features.component';
import { SuccessStoryComponent } from './pages/success-story/success-story.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { LicenseComponent } from './pages/license/license.component';
import { SupportComponent } from './pages/support/support.component';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { catchError, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

@Injectable({providedIn: 'root'})
export class TranslateTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);

    // During route extraction, skip translation to prevent timeouts
    if (isPlatformBrowser(this.platformId)) {
      // Only run the full translation logic in the browser
      try {
        if (title !== undefined) {
          this.translateService.get([title, 'app.title'])
            .pipe(
              catchError(() => of({ [title]: title, 'app.title': 'Qootaq' }))
            )
            .subscribe({
              next: (translations) => {
                const pageTitle = translations[title] || title;
                const appTitle = translations['app.title'] || 'Qootaq';
                this.title.setTitle(`${pageTitle} | ${appTitle}`);
              },
              error: () => {
                this.title.setTitle(title || 'Qootaq');
              }
            });
        } else {
          this.title.setTitle('Qootaq');
        }
      } catch (error) {
        this.title.setTitle(title || 'Qootaq');
      }
    } else {
      // During SSR/route extraction, use a simplified approach
      this.title.setTitle(title || 'Qootaq');
    }
  }
}

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'routes.home'
  },
  {
    path: 'features',
    component: FeaturesComponent,
    title: 'routes.features'
  },
  {
    path: 'testimonials',
    component: SuccessStoryComponent,
    title: 'routes.testimonials',
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    title: 'routes.contact_us'
  },
  {
    path: 'pricing',
    component: PricingComponent,
    title: 'routes.pricing'
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    title: 'routes.privacy_policy'
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
    title: 'routes.terms_of_service'
  },
  {
    path: 'license',
    component: LicenseComponent,
    title: 'routes.license'
  },
  {
    path: 'support',
    component: SupportComponent,
    title: 'routes.support'
  },
];
